//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function query(productId,storeId){
    return _axios({
        url: `/api/storeQuery/query?productId=${productId}&storeId=${storeId}`,
        method: 'get'
    })
}
